import React, {useState, useEffect, useRef} from "react";
import './TableOfContents.css'

export type Heading = {
  text: string;
  level: number;
  id: string;
};

type Props = {
  headings: Heading[];
};


const TableOfContents = (props: Props) => {
  const { headings } = props;
  //set the initial activeId to the id of the first heading
  const [activeId, setActiveId] = useState(headings[0].id);

  //initialize a useRef to reference the current scrollY position

   const scrollRef = useRef(0);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.getAttribute("id")!;
          if (entry.isIntersecting) {
            setActiveId(id);
            //Once an entry intersects, it records the window.scrollY position
            scrollRef.current = window.scrollY;
          } else {
            //check if the use is scrolling up by substracting the current scrollY from the previous scrollY
            //position. If >0 => we are scrolling up
            const diff = scrollRef.current - window.scrollY;
            const isScrollingUp = diff > 0;
            //find the previous headings's id and set it as the activeId if the we are scrolling up
            const currentIndex = headings.findIndex((h) => h.id === id);
            const prevEntry = headings[currentIndex-1];
            const prevId = prevEntry?.id;
            if (isScrollingUp && prevId) {
              setActiveId(id);
            }
          }
        });
      },
      {
        rootMargin: "0% 0% -85% 0%",
      }
    );

    headings.forEach((heading) => {
      const elem = document.getElementById(heading.id);
      if (elem) {
        observer.observe(elem);
      }
    });

    //clean up the observer when the component unmounts
    return () => observer.disconnect();
  }, [headings]);

  return (
    <div className="mb-20 margintoc">
      <b className="titleTOC">Table Of Contents</b>
      <ul className="m-0">
        {headings.map((heading) => {
          const id = heading.id;
          const activeClass = activeId === id ? "link-accent" : "";
          //identify the padding-left class modifier depending on the heading level
          const indentation = {
            3: " pl-2",
            4: " pl-4"
          };
          const level = heading.level as keyof typeof indentation;
          const paddingClass = indentation[level] ?? "";
          return (
            <li className="m-0" key={id} onClick={() => setActiveId(id)}>
              <a
                href={`#${id}`}
                className={`link ${activeClass}${paddingClass} spacelines`}>
                {heading.text}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default TableOfContents;
